import React, { useState, useEffect } from 'react';

const loadingMessages = [
  "Untangling your thoughts…",
  "Polishing your genius…",
  "Turning brainwaves into code waves…",
  "Loading extra smartness…",
  "Making sense of your brilliance…",
  "Shaking the magic 8-ball…",
  "Cooking up an answer…",
  "Teaching the AI new tricks…",
  "Sharpening virtual pencils…",
  "Warming up the thinking engines…",
  "Running on caffeine and algorithms…",
  "Summoning the code spirits…",
  "Untying digital knots…",
  "Conducting a byte-sized investigation…",
  "Diving into the matrix…",
  "Tickling the neural networks…",
  "Wrestling with your words…",
  "Polishing the crystal processor…",
  "Aligning ones and zeroes…",
  "Converting ideas into output…"
];

const LoadingMessages: React.FC = () => {
  const [currentMessage, setCurrentMessage] = useState(
    loadingMessages[Math.floor(Math.random() * loadingMessages.length)]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage(
        loadingMessages[Math.floor(Math.random() * loadingMessages.length)]
      );
    }, 2500); // Change message every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <p className="text-sm text-muted-foreground">
      {currentMessage}
    </p>
  );
};

export default LoadingMessages;